import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { TrailingStopDetailsImpl } from "../model/impl/TrailingStopDetailsImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class TrailingStopDetailsImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: TrailingStopDetailsImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.initialTrailingRt != null) {
      this.baseEncoder.writeStartFid(951, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(951),
        false,
        encodable.initialTrailingRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(951, streamout);
    }
    /*Object encoding*/
    if (encodable.trailingDistancePts != null) {
      this.baseEncoder.writeStartFid(952, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(952),
        false,
        encodable.trailingDistancePts,
        streamout,
      );
      this.baseEncoder.writeEndFid(952, streamout);
    }
    /*Object encoding*/
    if (encodable.invertTrailingDistancePts != null) {
      this.baseEncoder.writeStartFid(953, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(953),
        false,
        encodable.invertTrailingDistancePts,
        streamout,
      );
      this.baseEncoder.writeEndFid(953, streamout);
    }
    /*Object encoding*/
    if (encodable.initialTrackingRt != null) {
      this.baseEncoder.writeStartFid(954, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(954),
        false,
        encodable.initialTrackingRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(954, streamout);
    }
    /*Object encoding*/
    if (encodable.isInitialTrailingRateProvidedFg != null) {
      this.baseEncoder.writeStartFid(955, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(955),
        false,
        encodable.isInitialTrailingRateProvidedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(955, streamout);
    }
    /*Object encoding*/
    if (encodable.isTrackingActive != null) {
      this.baseEncoder.writeStartFid(956, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(956),
        false,
        encodable.isTrackingActive,
        streamout,
      );
      this.baseEncoder.writeEndFid(956, streamout);
    }
    /*Object encoding*/
    if (encodable.origTrackingRt != null) {
      this.baseEncoder.writeStartFid(957, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(957),
        false,
        encodable.origTrackingRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(957, streamout);
    }
    /*Object encoding*/
    if (encodable.trailingRt != null) {
      this.baseEncoder.writeStartFid(958, streamout);
      this.baseEncoder.writeObject(
        false,
        TrailingStopDetailsImplEncoder.fidTypeMap.get(958),
        false,
        encodable.trailingRt,
        streamout,
      );
      this.baseEncoder.writeEndFid(958, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,TrailingStopDetailsImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [951, "java.math.BigDecimal"],
    [952, "java.math.BigDecimal"],
    [953, "java.math.BigDecimal"],
    [954, "java.math.BigDecimal"],
    [955, "java.lang.Boolean"],
    [956, "java.lang.Boolean"],
    [957, "java.math.BigDecimal"],
    [958, "java.math.BigDecimal"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: TrailingStopDetailsImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 951: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(951),
            streamin,
          );
          encodable.initialTrailingRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 952: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(952),
            streamin,
          );
          encodable.trailingDistancePts = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 953: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(953),
            streamin,
          );
          encodable.invertTrailingDistancePts = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 954: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(954),
            streamin,
          );
          encodable.initialTrackingRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 955: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(955),
            streamin,
          );
          encodable.isInitialTrailingRateProvidedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 956: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(956),
            streamin,
          );
          encodable.isTrackingActive = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 957: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(957),
            streamin,
          );
          encodable.origTrackingRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 958: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TrailingStopDetailsImplEncoder.fidTypeMap.get(958),
            streamin,
          );
          encodable.trailingRt = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,TrailingStopDetailsImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return TrailingStopDetailsImplEncoder.fidTypeMap.has(fid);
  }
}
